import { render, staticRenderFns } from "./MembershipProductCard.vue?vue&type=template&id=67e1b6d8"
import script from "./MembershipProductCard.vue?vue&type=script&lang=js"
export * from "./MembershipProductCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports